import { render, staticRenderFns } from "./menu-releases.vue?vue&type=template&id=49966604&"
import script from "./menu-releases.vue?vue&type=script&lang=js&"
export * from "./menu-releases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports